export const AcceptCodesList = [
    'Accept with Loading ',
    'Accept with Sp Conditions ',
    'Accept with Loading + Sp Conditions ',
    'Accept_Loading Waiver ',
    'Accept_Spl Cond Waiver ',
    'Accept_Loading + Spl Cond Waiver ',
    'Accept _Loading waived_Spl Cond Applicable ',
    'Accept_Spl Cond Waived_Loading applicable ',
    'AcceptWithCounterOffer ',
    'AcceptWithLoadingCounterOffer ',
    'AcceptWithSpConditionsCounterOffer ',
    'AcceptWithLoadingSpConditionsCounterOffer ',
    'Accept with Co payment ',
    'Accept with Deductible ',
    'Accept with Co payment + Deductible ',
    'Accept with Loading + Co payment ',
    'Accept with Loading + Deductible ',
    'Accept with Loading + Co payment + Deductible ',
    'Accept with Loading + Sp Conditions + Co payment ',
    'Accept with Loading + Sp Conditions + Deductible ',
    'Accept with Loading + Sp Conditions + Co payment + Deductible ',
    'Accept with Sp Conditions + Co payment ',
    'Accept with Sp Conditions + Deductible ',
    'Accept with Sp Conditions + Co payment + Deductible ',
    'Accept with Co payment CounterOffer ',
    'Accept with Deductible CounterOffer ',
    'Accept with Loading + Co payment + CounterOffer ',
    'Accept with Loading + Deductible + CounterOffer ',
    'Accept with Sp Conditions + Co payment + CounterOffer ',
    'Accept with Sp Conditions + Deductible + CounterOffer ',
    'Accept with Loading + Sp Conditions + Co payment + CounterOffer ',
    'Accept with Loading + Sp Conditions + Deductible + CounterOffer ',
    'Accept with Loading + Sp Conditions + Co payment + Deductible + CounterOffer ',
    'Accept with Co payment + Deductible + CounterOffer ',
    'Accept with Sp Conditions + Co payment + Deductible + CounterOffer ',
    'Accept with Loading + Co payment + Deductible + CounterOffer '
]